import { WidgetContext } from "../types/WidgetContext";
import { isClient } from "./client";

export function log<T extends Record<string, any>>({
  tag,
  version,
  props,
  variables,
}: WidgetContext<T>) {
  const widget = {
    [`<${tag}>`]: version,
    props,
    variables,
  };
  console.debug(isClient() ? widget : JSON.stringify(widget));
}
